import { Routes } from '@angular/router';
import type { MenuItem } from '@onrsr/ui/layout';
import { AppAbility } from '../core/auth/ability';
import { routePermission } from '../core/auth/permission.guard';
import { routes } from '../app.routes';

export const MENU: MenuItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'tablerChartBar',
    route: '/dashboard',
  },
  {
    id: 'occurrences',
    label: 'Occurrences',
    icon: 'tablerLayoutGridAdd',
    children: [
      {
        id: 'awaiting-review',
        label: 'Awaiting Triage',
        route: '/occurrences/awaitingtriage',
      },
      {
        id: 'triage-review',
        label: 'Triage Review',
        route: '/occurrences/triagereview',
      },
    ],
  },
  {
    id: 'intelligence-review-group',
    label: 'IRG',
    icon: 'tablerUsers',
    route: '/irg',
    children: [
      {
        id: 'occurrence-review',
        label: 'Occurrence Review',
        route: '/irg',
      },
    ],
  },
  {
    id: 'office-management',
    label: 'Office Management',
    icon: 'tablerBuilding',
    children: [
      {
        id: 'my-favourites',
        label: 'My Favourites',
        route: '/officemanagement/myfavourites',
      },
      {
        id: 'assign-rso-office',
        label: 'Assign RSO Office',
        route: '/officemanagement/assignrsooffice',
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: 'tablerSettings',
    children: [
      {
        id: 'manage-prioritisation',
        label: 'Prioritisation Table',
        route: '/admin/prioritisation',
      },
      {
        id: 'history',
        label: 'History',
        route: '/admin/history',
      },
      {
        id: 'access-control',
        label: 'Access Control',
        route: '/admin/access',
      },
      {
        id: 'session-expiry-demo',
        label: 'Session Expiry Demo',
        route: '/admin/session',
      },
    ],
  },
];

/** Menu items whose route the ability may activate; groups with no permitted children are dropped. */
export function menuItemsFor(ability: AppAbility, items: MenuItem[] = MENU, routeTable: Routes = routes): MenuItem[] {
  return items.flatMap((item) => {
    if (item.children) {
      const children = menuItemsFor(ability, item.children, routeTable);
      return children.length ? [{ ...item, children }] : [];
    }
    return canActivateRoute(ability, item.route, routeTable) ? [item] : [];
  });
}

function canActivateRoute(ability: AppAbility, route: string | undefined, routeTable: Routes): boolean {
  const path = route?.replace(/^\//, '');
  const target = routeTable.find((candidate) => candidate.path === path);
  const permission = target ? routePermission(target) : undefined;
  return !permission || ability.can(permission.action, permission.subject);
}
